import React, {
  createContext,
  PropsWithChildren,
  useState,
  useContext,
} from 'react';
import { AuthorityCodesDashboard } from '@/core/domain/enterprise/Authority/Authority.types';

type DashboardContextParams = {
  dashboardType: AuthorityCodesDashboard;
  setDashboardType: (dashboardType: AuthorityCodesDashboard) => void;
};

const DashboardContext = createContext({} as DashboardContextParams);

export const useDashboardContext = () => useContext(DashboardContext);

const DASHBOARD_TYPE_KEY = 'ultracar/DashboardType';

const DashboardContexProvider: React.FC<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [dashboardType, handleDashboardType] =
    useState<AuthorityCodesDashboard>(
      () =>
        (localStorage.getItem(DASHBOARD_TYPE_KEY) as AuthorityCodesDashboard) ||
        AuthorityCodesDashboard.managerView,
    );

  function setDashboardType(type: AuthorityCodesDashboard) {
    localStorage.setItem(DASHBOARD_TYPE_KEY, type);
    handleDashboardType(type);
  }

  return (
    <DashboardContext.Provider value={{ dashboardType, setDashboardType }}>
      {children}
    </DashboardContext.Provider>
  );
};

export default DashboardContexProvider;
